import { render } from "./inviteToBalanceOrCoupon.vue?vue&type=template&id=36d297a4&scoped=true"
import script from "./inviteToBalanceOrCoupon.vue?vue&type=script&lang=js"
export * from "./inviteToBalanceOrCoupon.vue?vue&type=script&lang=js"

import "./inviteToBalanceOrCoupon.vue?vue&type=style&index=0&id=36d297a4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d297a4"]])

export default __exports__